import type { IconData } from '@stacksjs/iconify-core'

export const be4x3: IconData = {
  "body": "<g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"#000001\" d=\"M0 0h213.3v480H0z\"/><path fill=\"#ffd90c\" d=\"M213.3 0h213.4v480H213.3z\"/><path fill=\"#f31830\" d=\"M426.7 0H640v480H426.7z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default be4x3
